// extracted by mini-css-extract-plugin
export var checkbox = "_8s-0";
export var circle = "_8s-3";
export var horizontalContainer = "_8s-7";
export var sm = "_8s-5";
export var switch0 = "_8s-2";
export var switchDisabled = "_8s-8";
export var switchEnabled = "_8s-1";
export var textSwitchContainer = "_8s-9";
export var textSwitchOption = "_8s-a";
export var textSwitchOptionSelected = "_8s-b";
export var verticalContainer = "_8s-6";
export var xs = "_8s-4";